import { Activity } from 'react'
import type { Notification } from '../../../../types'
import { useLocalization } from '../../../../i18n'
import { formatNotificationDate } from '../../../../utils/notificationUtils'
import styles from './notificationItem.module.css'

interface NotificationItemProps {
  notification: Notification
  onMarkAsRead: (id: string) => void
}

export function NotificationItem({ notification, onMarkAsRead }: NotificationItemProps) {
  const { t } = useLocalization()

  const handleClick = () => {
    if (!notification.isWatched) {
      onMarkAsRead(notification.id)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick()
    }
  }

  return (
    <div
      className={`${styles.item} ${!notification.isWatched ? styles.unread : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`${notification.message}. ${formatNotificationDate(notification.createDate, t)}`}
    >
      <div className={styles.content}>
        <p className={styles.message}>{notification.message}</p>
        <span className={styles.date}>
          {formatNotificationDate(notification.createDate, t)}
        </span>
      </div>
      <Activity mode={!notification.isWatched ? 'visible' : 'hidden'}>
        <div className={styles.indicator} aria-label="Unread" />
      </Activity>
    </div>
  )
}
